module.exports = __webpack_public_path__ + "img/cell_size_1.e1f1f60a.svg";